import React from 'react'

/**
 * Renders the standard official site banner indicating that this site is an
 * official government site.
 *
 * This component is usually rendered in the common {@link Header}. You should
 * only need to add this manually if you are implementing your own header.
 * In that case, this should be the element that is at the very top of the
 * window.
 *
 * For more information, please consult the
 * [U.S. Web Design Standards](https://standards.usa.gov).
 */
const OfficialSiteBanner = ({fluid, message, ...rest}) => {
  
  return (
    <div className="bg-gray-400 lg:block hidden" {...rest}>
      <div className="container">
        <div className="flex">
          <img 
            src="https://www.irs.gov/themes/custom/pup_base/images/official-site-flag.png" 
            width="24px" 
            height="17px" 
            className="mr-3"
            alt="U.S. Flag"
            style={{width: "24px", height: "17px", marginTop: "4px"}} />
          <span className="text-xs my-1plus">{message ? message : "An official website of the United States Government"}</span>
        </div>
      </div>
    </div>
  )
}

export default OfficialSiteBanner
